import React, { memo } from "react"

const FormError = memo((props: Props) => {
  const { error, info } = props
  return (
    <>
      <div className="text-sm">*{error}</div>
      {info && <div dangerouslySetInnerHTML={{ __html: info }} />}
    </>
  )
})

export { FormError }

interface Props {
  error: string | any
  info?: string | any
}
